var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab_wrap"},[_c('ul',_vm._l((_vm.navArr),function(item,index){return _c('li',{key:index,on:{"click":function($event){_vm.tabClick(index)}}},[_c('div',{class:{'active' : _vm.navIndex == index}},[_vm._v("\n                "+_vm._s(item)+"\n            ")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f58d5a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layer/tab-nav.vue
// module id = null
// module chunks = 